import { render, staticRenderFns } from "./locales.vue?vue&type=template&id=02c5cb03"
import script from "./locales.vue?vue&type=script&lang=js"
export * from "./locales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports